import { useState, useRef, useEffect } from "react";

const DoctorProfile = ({ biography, aboutImage, name }) => {
  const [showAllContent, setShowAllContent] = useState(false);
  const [contentExceedsHeight, setContentExceedsHeight] = useState(false);
  const [initialHeight, setInitialHeight] = useState("200px");
  const contentRef = useRef(null);
  const imageContainerRef = useRef(null);

  useEffect(() => {
    const updateContentHeight = () => {
      if (contentRef.current && imageContainerRef.current) {
        const containerWidth = imageContainerRef.current.offsetWidth;
        const imageHeight = containerWidth; // Since we're using 1:1 aspect ratio
        const contentHeight = contentRef.current.scrollHeight;

        // In mobile view, use 200px as initial height
        const isMobileView = window.innerWidth < 992;
        const maxInitialHeight = isMobileView ? 200 : imageHeight;

        setInitialHeight(`${maxInitialHeight}px`);

        if (contentHeight > maxInitialHeight) {
          setContentExceedsHeight(true);
          setShowAllContent(false);
        } else {
          setContentExceedsHeight(false);
          setShowAllContent(true);
        }
      }
    };

    updateContentHeight();
    window.addEventListener("resize", updateContentHeight);

    return () => {
      window.removeEventListener("resize", updateContentHeight);
    };
  }, [biography.content.length]);

  const toggleContent = () => {
    setShowAllContent(!showAllContent);
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-12 h-100">
          <div
            className="car shadow-sm"
            style={{ backgroundColor: "#e3f2fd", border: "none" }}
          >
            <div className="card-body p-4">
              <div className="row justify-content-center">
                {/* Image Column */}
                <div
                  className="col-12 col-sm-10 col-lg-4 mb-4"
                  ref={imageContainerRef}
                >
                  <div
                    className="position-relative"
                    style={{ paddingBottom: "100%", height: 0 }}
                  >
                    <img
                      src={biography.image.url}
                      alt={aboutImage.alt}
                      className="img-fluid rounded shadow-sm position-absolute"
                      style={{
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "top",
                      }}
                    />
                  </div>
                </div>

                {/* Content Column */}
                <div className="col-12 col-sm-10 col-lg-8">
                  <h2
                    className="mb-3"
                    style={{ color: "black", fontWeight: "600" }}
                  >
                    Learn More About {name}'s Impact
                  </h2>

                  <h4
                    className="mb-3"
                    style={{
                      color: "#137CFF",
                      fontWeight: "bold",
                      fontSize: "1.1rem",
                    }}
                  >
                    BIOGRAPHY
                  </h4>

                  <div
                    ref={contentRef}
                    className="text-muted doctor-profile-content"
                    style={{
                      lineHeight: "1.6",
                      fontSize: "1rem",
                      overflow: "hidden",
                      maxHeight: showAllContent ? "none" : initialHeight,
                      position: "relative",
                      transition: "max-height 0.3s ease-out",
                    }}
                  >
                    {biography.content.map(
                      (paragraph, index) =>
                        paragraph && (
                          <p
                            key={index}
                            className={
                              index < biography.content.length - 1
                                ? "mb-4"
                                : "mb-0"
                            }
                          >
                            {paragraph}
                          </p>
                        )
                    )}

                    {!showAllContent && contentExceedsHeight && (
                      <div
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          right: 0,
                          height: "100px",
                          background:
                            "linear-gradient(to bottom, rgba(227, 242, 253, 0) 0%, rgba(227, 242, 253, 0.9) 50%, rgba(227, 242, 253, 1) 100%)",
                          pointerEvents: "none",
                        }}
                      />
                    )}
                  </div>

                  {contentExceedsHeight && (
                    <button
                      onClick={toggleContent}
                      className="btn btn-link p-0 mt-3"
                      style={{
                        color: "#137CFF",
                        textDecoration: "none",
                        fontWeight: "500",
                      }}
                    >
                      {showAllContent ? "View Less" : "View More"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorProfile;
